import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

Vue.config.devtools = true;

import uxModule from "./Modules/uxModule";
import sharedModule from "./Modules/sharedModule";
import securityModule from "./Modules/securityModule";
import clientModule from "./Modules/clientModule";
import optionsModule from "./Modules/optionsModule";
import filesModule from "./Modules/filesModule";
import plansModule from "./Modules/plansModule";
const state = {};

const mutations = {};

const actions = {};

const store = new Vuex.Store({
  modules: {
    uxModule: uxModule,
    sharedModule: sharedModule,
    securityModule: securityModule,
    clientModule: clientModule,
    optionsModule: optionsModule,
    filesModule: filesModule,
    plansModule: plansModule,
  },

  state,
  mutations,
  actions,
  //plugins: [
  //  createPersistedState({
  //    storage: window.sessionStorage,
  //  }),
  //],
});

export default store;
